import { TextAvatar, CustomButton, CustomInput } from '@/shared/ui/components';
import { generateFullName } from '@/shared/lib';
import { t } from 'ttag';
import { useCommentInput } from './useCommentInput';
import type { CommentInputProps } from './commentInput.types';

/**
 * Comment composer of the support request detail page. Shows the signed-in user's avatar and generateFullName name from meRedux, a textarea bound to state.content through onChange, and a Send button disabled by isDisabled that calls onClickSend and reflects state.isSaving.
 *
 * @param onSubmit - Callback receiving the composed comment text.
 * @returns The comment input element.
 */
const CommentInput = ({ onSubmit }: CommentInputProps) => {
  const { meRedux, state, isDisabled, onChange, onClickSend } = useCommentInput({ onSubmit });

  return (
    <div id="comment-input">
      <div className="part-user">
        <div className="user">
          <TextAvatar data={meRedux} />
          <div className="user-info">
            <div className="name">{generateFullName(meRedux)}</div>
          </div>
        </div>
        <CustomButton
          style="default"
          type="primary"
          size="small"
          id="send-btn"
          disabled={isDisabled}
          loading={state.isSaving}
          onClick={onClickSend}
        >
          {t`Send`}
        </CustomButton>
      </div>
      <div className="text-input">
        <CustomInput
          className="message-text"
          placeholder={t`Enter your message`}
          type="textarea"
          value={state.content}
          onChange={onChange}
          name="content"
          allowClear={false}
          disabled={state.isSaving}
        />
      </div>
    </div>
  );
};

export default CommentInput;
